import React from 'react';
import styled from 'styled-components';
import Icon from '../../common/styles/Icon';

interface AccountIconProps {
  onClick?: () => void;
}

const AvatarIcon = styled(Icon)`
  &::before {
    font-size: 20px;
    line-height: normal;
    vertical-align: middle;
  }
`;

const AccountIcon: React.FC<AccountIconProps> = ({ onClick }) => (
  <AvatarIcon iconName="user-off" onClick={onClick} leftOfText />
);

export default AccountIcon;
